module.exports = __webpack_public_path__ + "static/media/flowchart_construction_collage.7c81bbe0.jpg";